import { render } from "./User.vue?vue&type=template&id=540807ea"
import script from "./User.vue?vue&type=script&lang=ts"
export * from "./User.vue?vue&type=script&lang=ts"

import "./User.vue?vue&type=style&index=0&id=540807ea&lang=css"
script.render = render

export default script